<div 
  class="app-alert"
  [ngClass]="'app-alert--' + type"
  [class.app-alert--dark]="theme === 'dark'"
  [class.app-alert--light]="theme === 'light'">
  <ng-content></ng-content>
</div>